import { render } from "./DesignerEditor.vue?vue&type=template&id=d1573ff6"
import script from "./DesignerEditor.vue?vue&type=script&lang=js"
export * from "./DesignerEditor.vue?vue&type=script&lang=js"

import "./DesignerEditor.vue?vue&type=style&index=0&id=d1573ff6&lang=scss"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__